import React from "react";
import QnaCard from "./QnaCard";
import MyPageEmpty from "./MyPageEmpty";
import "../styles/QnaManagementSection.css";

const QnaManagementSection = ({ qnaList, qnaCount, refreshQnaData }) => {

    if (qnaCount === 0) {
        return <MyPageEmpty />;
    }


    return (
        <div className="mypage-qna-section">
            <div className="mypage-qna-header">
                <h3 className="mypage-qna-title">Q&A 관리</h3>
                <button className="mypage-qna-more-btn">더보기 &gt;</button>
            </div>
            <div>
                <h4 className="mypage-review-count">내가 작성한 Q&A {qnaCount}개</h4>
            </div>

            {/* 데이터가 없을 경우 */}
            {qnaList.length === 0 ? <MyPageEmpty/> : (
                <div className="qna-list">
                    {qnaList.map((item) => (
                        <QnaCard key={item.id} item={item} refreshQnaData={refreshQnaData}/>
                    ))}
                </div>
            )}
        </div>
    );
};

export default QnaManagementSection;
